import { render } from "./Parents2.vue?vue&type=template&id=2695571b&scoped=true"
import script from "./Parents2.vue?vue&type=script&lang=js"
export * from "./Parents2.vue?vue&type=script&lang=js"

import "./Parents2.vue?vue&type=style&index=0&id=2695571b&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2695571b"]])

export default __exports__